import React from "react";

function IconStarTrue(props) {
  return (
    <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 270 258"
        >
        <path
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M11639.8 3287.22c.9-1.73 2.6-2.83 4.5-2.83 2 0 3.7 1.1 4.5 2.83 11.1 22.85 38.5 79.71 38.5 79.71s62.6 8.52 87.7 11.95c1.9.26 3.5 1.59 4.1 3.41.6 1.83.1 3.84-1.3 5.16-18.3 17.55-63.9 61.22-63.9 61.22l15.7 87.1c.3 1.89-.4 3.81-2 4.94-1.5 1.13-3.6 1.27-5.3.36-22.3-12.01-78-41.88-78-41.88s-55.6 29.87-77.9 41.88c-1.7.91-3.8.77-5.4-.36-1.5-1.13-2.3-3.05-1.9-4.94l15.7-87.1s-45.6-43.67-63.9-61.22a4.96 4.96 0 01-1.3-5.16c.6-1.82 2.2-3.15 4.1-3.41 25.1-3.43 87.7-11.95 87.7-11.95s27.4-56.86 38.4-79.71z"
            transform="translate(-11509.3 -3284.39)"
        ></path>
        </svg>
    </div>
  );
}

export default IconStarTrue;
